/**
 * useRBAC — Role-Based Access Control hook.
 *
 * Returns the effective role for the current authenticated user,
 * or null while the role is still loading.
 */
export function useEffectiveRole(): string | null {
  // Stub — full RBAC not yet implemented. Default to "Operator" in dev so
  // the dispatcher routes to a real screen instead of FullScreenSpinner.
  // Override via localStorage.setItem("devRole", "Admin" | "Operator" | "Viewer").
  if (typeof window !== "undefined") {
    const override = window.localStorage.getItem("devRole");
    if (override) return override;
  }
  return "Operator";
}
